module.exports = __webpack_public_path__ + "static/media/page-8.2d5ace31.png";